(function(){
  'use strict';
  function pad(n){return n<10?'0'+n:''+n;}

  function render(el,ms){
    var out=el.querySelector('[data-tz-clock]');
    if(!out)return;
    if(ms<=0){el.remove();return;}
    var s=Math.floor(ms/1000);
    var d=Math.floor(s/86400);
    var h=Math.floor((s%86400)/3600);
    var m=Math.floor((s%3600)/60);
    var sec=s%60;
    out.textContent=(d>0?d+'d ':'')+pad(h)+':'+pad(m)+':'+pad(sec);
  }

  function start(el){
    var mode=el.getAttribute('data-mode');
    var target=null;

    if(mode==='countdown'){
      var raw=el.getAttribute('data-deadline');
      if(!raw)return;
      var parsed=new Date(raw.replace(' ','T'));
      if(isNaN(parsed.getTime()))return;
      target=parsed.getTime();
    }else if(mode==='cutoff'){
      var hour=parseInt(el.getAttribute('data-cutoff')||'0',10);
      var now=new Date();
      var next=new Date(now.getFullYear(),now.getMonth(),now.getDate(),hour,0,0,0);
      if(next.getTime()<=now.getTime()){
        /* Cutoff already passed today — this message is no longer true, so hide it. */
        el.remove();
        return;
      }
      target=next.getTime();
    }else{
      return;
    }

    render(el,target-Date.now());
    var id=setInterval(function(){
      var left=target-Date.now();
      if(left<=0){clearInterval(id);}
      render(el,left);
    },1000);
  }

  function init(root){
    (root||document).querySelectorAll('[data-tz-urgency]:not([data-bound])').forEach(function(el){
      el.setAttribute('data-bound','1');
      start(el);
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){init(document);});
  }else{init(document);}
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();